import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AppInfo from './pages/AppInfo.js';
import Recipes from './pages/Recipes.js';
import Recipe from './pages/Recipe.js';
import INF from './pages/infPages/INF.js';
import PageNotFound from './pages/PageNotFound.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <BrowserRouter>
       <Routes>
        <Route path="/" element={ <App/> } />
        <Route path="/info" element={ <AppInfo/> } />
        <Route path="/recipes" element={ <Recipes/> } />
        <Route path="/recipes/:recipeName" action={({ params }) => {}} element={ <Recipe />}/>
        <Route path="/instantnoodlefactory" element={ <INF/> } />
        <Route path="*" element={ <PageNotFound/> } />
      </Routes>
      </BrowserRouter>,
    );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();